<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">{{ $t('word.importList.subtitle') }}</span>
        <h3 class="page-title d-inline">{{ $t('word.importList.title') }}</h3>
        <router-link class="btn btn-success text-white float-right ml-1" :to="{ name: 'admin-word-import-new' }">
          {{ $t('word.importList.add') }}
        </router-link>
      </div>
    </d-row>

    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-between align-items-center">
            <div class="col-6">
              <h6 class="m-0">{{ $t('word.importList.cardTitle') }}</h6>
            </div>

            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"/>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    :placeholder="$t('word.importList.searchPlaceholder')"
                    :aria-label="$t('shared.actions.search')"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>

          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <word-import-table :imports="history.list" />
            </div>
            <pagination :total-items="history.total_items" :pagination.sync="pagination"/>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import WordImportTable from '../components/WordImportTable.vue';

export default {
  name: 'word-import-list',
  components: {
    Pagination,
    WordImportTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number) || 1,
      },
    };
  },
  computed: {
    history() {
      const { importHistoryList } = this.$store.state.word;

      if (importHistoryList && importHistoryList.list && importHistoryList.list.length) {
        return importHistoryList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'getImportHistoryList',
    ]),
    getList() {
      this.getImportHistoryList(this.pagination);
    },
  },
  destroyed() {
    Events.$off('update:pagination');
  },
  mounted() {
    Events.$emit('sidebarVisible', false);

    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });

    this.getList();
  },
};
</script>
